import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import { changeSkin } from '@/utils/common.js';

export default {
  components: {
    Pagination
  },
  data() {
    return {
      tabActiveType: '1',
      newsList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  created() {
    this.getNewsList();
  },
  watch: {
    $route () {
      this.getNewsList();
    }
  },
  computed: {
  },
  methods: {
    changeSkin,
    // formate日期
    getCreatedTimeDay (date) {
      const baseDateFilter = this.$options.filters['baseDate'];
      const baseDate = baseDateFilter(date);
      return baseDate.substring(8, 10);
    },
    getCreatedTimeYear (date) {
      const baseDateFilter = this.$options.filters['baseDate'];
      const baseDate = baseDateFilter(date);
      return baseDate.substring(0, 7);
    },
    // 详情
    toDetailPage(id) {
      this.$router.push({
        path: '/news/news-detail',
        query: {
          id: id
        }
      });
    },
    changeTabIndex(type) {
      this.tabActiveType = type;
      this.getNewsList();
    },
    getNewsList(page) {
      if (page) {
        this.pageNum = page.pageNo;
        this.pageSize = page.pageSize;
      }
      const type = this.$route.params.type;
      const params = {type: 1, partId: type, pageNum: this.pageNum, pageSize: this.pageSize};
      Service.getNewsList(params).then(res => {
        if (res && res.code === '0') {
          this.total = res.data.total;
          this.newsList = res.data.list;
          this.news1 = this.newsList[0];
        }
      });
    }
  }
};
